<!--
 * @Author: QiTianDaSheng
 * @Date: 2023-07-17 16:11:20
 * @Descripttion: 
 * @LastEditors: QiTianDaSheng
 * @LastEditTime: 2023-08-05 18:04:21
-->
<!-- 一体化服务平台提升企业管理效率 -->
<!-- :style="{ 'background-image': item.isActive ? 'url(' + item.hoverLink + ')':'url(' + item.link + ')',
'background-size':' 100% 100%;','width': item.isActive ? '426px' : '138px'}" -->
<template>
    <div class="integrationBox">
        <div class="integration">
            <div class="integration_title"></div>
            <div class="integration_content">
                <div class="integration_item" :class="{'active':item.id == onId}"
                    :style="{ 'background-image': item.id == onId ? 'url(' + item.hoverLink + ')':'url(' + item.link + ')'}" v-for="(item, index) in imageList"
                    :key="item.id" @mouseover="handleMouseOver(index,item.id)" @mouseout="handleMouseOut(index,item.id)">
                    <div class="integration_icon" :class="{'active':item.id == onId}"
                        :style="{'background-image': item.id == onId ? 'url(' + item.secondIcon + ')':'url(' + item.icon + ')'}"></div>
                    <div class="integration_subtitle" v-if="item.id != onId">
                        {{ item.title }}
                    </div>
                    <div class="active_info" v-else>
                        <div class="integration_subtitle_active">
                            {{ item.title }}
                        </div>
                        <div class="line"></div>
                        <div class="info">
                            {{ item.activeInfo}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      flag: false,
      showIcon: true,
      onId: 1,
      paused: false, // 停止轮询
      intervalTime: null, // 定时轮询的计时器
      imageList: [
        {
          id: 1,
          link: require('../../../assets/image/home/platform_bg_01.png'),
          hoverLink: require('../../../assets/image/home/integration_bg_01.png'),
          icon: require('../../../assets/image/home/integration_icon_01.png'),
          secondIcon: require('../../../assets/image/home/integration_icon_active1.png'),
          title: 'AI财务管理',
          activeInfo: '智能化数据分析、风险监控，自动化管理生成报表以及各类数据的准确分析，以智能办公提高工作效率。',
          isActive: true,
        },
        {
          id: 2,
          link: require('../../../assets/image/home/platform_bg_02.png'),
          hoverLink: require('../../../assets/image/home/integration_bg_02.png'),
          icon: require('../../../assets/image/home/integration_icon_02.png'),
          secondIcon: require('../../../assets/image/home/integration_icon_active2.png'),
          title: '智能票税管理',
          activeInfo:
            '在数智税方面实现自动发票管理,包括发票录入、识别、核对、报税,以及提供发票警报功能,实时监测及检测异常发票。帮助企业降低税务风险，提高财务管理的准确性和合规性。',
          isActive: false,
        },
        {
          id: 3,
          link: require('../../../assets/image/home/platform_bg_03.png'),
          hoverLink: require('../../../assets/image/home/integration_bg_03.png'),
          icon: require('../../../assets/image/home/integration_icon_03.png'),
          secondIcon: require('../../../assets/image/home/integration_icon_active3.png'),
          title: '企业管理',
          activeInfo: '基于互联网技术，提供智能化的协同办公解决方案，提高企业内部沟通与协作效率，降低管理成本。',
          isActive: false,
        },
        {
          id: 4,
          link: require('../../../assets/image/home/platform_bg_04.png'),
          hoverLink: require('../../../assets/image/home/integration_bg_04.png'),
          icon: require('../../../assets/image/home/integration_icon_04.png'),
          secondIcon: require('../../../assets/image/home/integration_icon_active4.png'),
          title: '法务、税务咨询',
          activeInfo: '为客户提供全面的法务和税务咨询服务，帮助企业处理法律事务、合规问题和税务筹划，实现高效的法务税务管理。',
          isActive: false,
        },
        {
          id: 5,
          link: require('../../../assets/image/home/platform_bg_05.png'),
          hoverLink: require('../../../assets/image/home/integration_bg_05.png'),
          icon: require('../../../assets/image/home/integration_icon_05.png'),
          secondIcon: require('../../../assets/image/home/integration_icon_active5.png'),
          title: '智慧金融',
          activeInfo: '为中小企业解决融资难题，到账快、额度高、无压力、申请易，助力中小企业实现稳定发展。',
          isActive: false,
        },
        {
          id: 6,
          link: require('../../../assets/image/home/platform_bg_06.png'),
          hoverLink: require('../../../assets/image/home/integration_bg_06.png'),
          icon: require('../../../assets/image/home/integration_icon_06.png'),
          secondIcon: require('../../../assets/image/home/integration_icon_active6.png'),
          title: '聚合支付',
          activeInfo: '移动互联网时代的首选支付解决方案，为商家和消费者提供便捷、安全和高效的支付体验，让支付过程更加简单。',
          isActive: false,
        },
      ],
    }
  },
  methods: {
    // 鼠标移入
    handleMouseOver(index, id) {
      this.imageList[index].isActive = true
      this.onId = id
      clearInterval(this.intervalTime)
    },
    // 鼠标移出
    handleMouseOut(index, id) {
      this.imageList[index].isActive = false
      this.onId = id
      this.startPolling()
    },
    // 开始轮询
    startPolling() {
      this.intervalTime = setInterval(() => {
        if (this.onId < 6) {
          this.onId += 1
        } else {
          this.onId = 1
        }
      }, 4000) // 设置定时轮询的间隔时间，这里设置为 5000ms（5秒）
    },
  },
  mounted() {
    this.startPolling() // 组件挂载后开始定时轮询
  },
  beforeDestroy() {
    clearInterval(this.intervalTime)
  }, //生命周期 - 销毁之前
}
</script>
<style scoped lang="scss">
.integrationBox {
  width: 100%;
  height: 700px;
  margin-top: 145px;
  background-color: #fff;

  .integration {
    width: 1200px;
    margin: 0 auto;
    .integration_title {
      width: 779px;
      height: 94px;
      margin: 71px auto 56px;
      background: url('../../../assets/image/home/integration_title.png');
      background-size: 100% 100%;
    }
    .integration_content {
      display: flex;
      justify-content: space-between;
    }
    .integration_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 138px;
      height: 540px;
      transition: 0.2s cubic-bezier(0.05, 0.61, 0.41, 0.95);
      background-size: 100% 100%;
      &.active {
        width: 426px;
        height: 540px;
      }
      .integration_icon {
        width: 66px;
        height: 66px;
        background-size: 100% 100%;
        &.active {
          width: 112px;
          height: 112px;
          background-size: 100% 100%;
        }
      }
      .integration_subtitle {
        height: 25px;
        font-size: 18px;
        font-weight: 600;
        color: #ffffff;
        line-height: 25px;
        margin-top: 9px;
      }
      .integration_subtitle_active {
        height: 28px;
        font-size: 20px;
        font-weight: 700;
        color: #ffffff;
        line-height: 28px;
        margin-top: 16px;
      }
      .active_info {
        width: auto;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      .line {
        width: 33px;
        height: 2px;
        border-radius: 2px;
        background: #ffffff;
        margin: 25px;
      }
      .info {
        width: 280px;
        overflow: hidden;
        text-align: center;
        height: 126px;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        line-height: 30px;
      }
    }
  }
}
</style>

